import * as THREE from 'three';

export class CupPinTarget {
  readonly object3D = new THREE.Group();
  readonly cupRadiusMeters = 0.054;
  private readonly materials: THREE.Material[] = [];

  constructor(position: THREE.Vector3) {
    this.object3D.name = 'CupPinTarget';
    const cupMat = new THREE.MeshBasicMaterial({
      color: 0x111111,
      transparent: true,
      opacity: 0.9,
    });
    const rimMat = new THREE.MeshBasicMaterial({
      color: 0xf7f7f1,
      transparent: true,
      opacity: 0.95,
    });
    const flagMat = new THREE.MeshStandardMaterial({ color: 0xffef66, roughness: 0.55 });
    const poleMat = new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.4 });
    this.materials.push(cupMat, rimMat, flagMat, poleMat);

    const cup = new THREE.Mesh(new THREE.CircleGeometry(this.cupRadiusMeters, 40), cupMat);
    cup.name = 'CupDisc';
    cup.rotation.x = -Math.PI / 2;
    cup.position.y = 0.012;
    const rim = new THREE.Mesh(new THREE.TorusGeometry(this.cupRadiusMeters, 0.012, 8, 48), rimMat);
    rim.name = 'CupRim';
    rim.rotation.x = Math.PI / 2;
    rim.position.y = 0.018;
    const pole = new THREE.Mesh(new THREE.CylinderGeometry(0.018, 0.018, 2.4, 12), poleMat);
    pole.name = 'PinPole';
    pole.position.y = 1.2;
    const flag = new THREE.Mesh(new THREE.PlaneGeometry(0.72, 0.42), flagMat);
    flag.name = 'PinFlag';
    flag.position.set(0.36, 2.08, 0);
    this.object3D.add(cup, rim, pole, flag);
    this.object3D.position.copy(position);
  }

  setPosition(position: THREE.Vector3): void {
    this.object3D.position.copy(position);
  }

  setGroundHeight(height: number): void {
    this.object3D.position.y = height;
  }

  dispose(): void {
    this.object3D.traverse((child) => {
      if (child instanceof THREE.Mesh) child.geometry.dispose();
    });
    this.materials.forEach((material) => material.dispose());
  }
}
